import { z } from 'zod';

export const stockItemSchema = z.object({
  itemId: z.string(),
  itemName: z.string(),
  sku: z.string(),
  category: z.string(),
  currentQuantity: z.number(),
  unit: z.string(),
  reorderPoint: z.number(),
  storageLocationId: z.string(),
  storageLocationName: z.string(),
  lastUpdated: z.string(),
});

export type StockItem = z.infer<typeof stockItemSchema>;

export const stockLevelsResponseSchema = z.object({
  data: z.array(stockItemSchema),
  pagination: z.object({
    nextToken: z.string().nullable(),
    totalCount: z.number(),
  }),
  meta: z.object({siteId: z.string(),}),
});

export type StockLevelsResponse = z.infer<typeof stockLevelsResponseSchema>;

export interface StockFilters {
  storageLocationId?: string;
  category?: string;
  lowStockOnly?: boolean;
}

export type StockStatus = 'in-stock' | 'low-stock' | 'out-of-stock';

export function getStockStatus(item: StockItem): StockStatus {
  if (item.currentQuantity === 0) return 'out-of-stock';
  if (item.currentQuantity <= item.reorderPoint) return 'low-stock';
  return 'in-stock';
}
